// Evidence Collection Module Translation Summary
import recommendation from "./recommendation.js";
import uploadOld from "./uploadOld.js";
import investigation from "./investigation.js";

export default {
  recommendation,
  uploadOld,
  investigation,
};
